import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePrefs } from 'wsm-common-data';
import { ErrorBoundary } from 'wsm-error-boundary';
import logger from 'ws-scripts/modules/logger';

import PaymentSelectorView from '../components/PaymentSelectorView';
import StepContainer from '../components/StepContainer';
import { LOGGING_ATTR_PREFIX } from '../constants';
import { setSteps } from '../features/steps/stepsSlice';
import { setVehicleId } from '../features/vehicleId/vehicleIdSlice';
import { setListingType } from '../features/listingType/listingTypeSlice';
import {
	getLsWidgetStateByVehicleId,
	migrateLsStepsWithEnabledFlags
} from '../helpers';
import { errorBoundaryHandler } from '../helpers/logging-client';

import '../global-sass/main.scss';

const Widget = () => {
	const { trackMyOfferView } = usePrefs();
	const dispatch = useDispatch();
	const steps = useSelector((state) => state.steps);
	const isPaymentSelectorView = trackMyOfferView === 'paymentSelector';

	useEffect(() => {
		try {
			// TODO: refactor to set these on server side
			// Safe access with optional chaining
			const uuid = window?.DDC?.dataLayer?.vehicles?.[0]?.uuid || '';
			const listingType =
				window?.DDC?.dataLayer?.vehicles?.[0]?.inventoryType || '';

			// payment selector view handles read, write from local storage and publish steps to step tracker
			if (uuid && isPaymentSelectorView) {
				const lsSteps = getLsWidgetStateByVehicleId(uuid, steps);

				// Migrate the lsStep (add enabled flag from server state)
				const migratedSteps = migrateLsStepsWithEnabledFlags(
					lsSteps,
					steps
				);

				// TODO: validate LS steps before pushing to state
				dispatch(setSteps(migratedSteps));

				// TODO: refactor to set these on server side
				dispatch(setVehicleId(uuid));
				dispatch(setListingType(listingType));
			}
		} catch (error) {
			logger.error(
				`${LOGGING_ATTR_PREFIX}: Widget initialization failed`,
				error
			);
			// Widget still renders with server-set state
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return isPaymentSelectorView ? <PaymentSelectorView /> : <StepContainer />;
};

Widget.propTypes = {};

// Wrap Widget with ErrorBoundary to prevent crashes from breaking the page
const WidgetWithErrorBoundary = () => (
	<ErrorBoundary
		errorMarkup={<div>There was an error retrieving payment info.</div>}
		errorHandler={errorBoundaryHandler}
		newRelicPageAction={`${LOGGING_ATTR_PREFIX}-error-boundary`}
	>
		<Widget />
	</ErrorBoundary>
);

export default WidgetWithErrorBoundary;
